/* Provides bolt-on functionality for the _multiSelectField.gsp for
 the system messages administration page, which required some fairly
 complex logic for a highly generic component.*/

var candidateMultiselectRoleTypeController = function ($scope) {

  // used to save the state of the RoleType multiselect field to avoid user loosing work
  let checkboxState = [];
  $scope.isCandidateChecked = false;
  $scope.procurerIsChecked = false;
  $scope.supportSupplierIsChecked = false;
  $scope.umbrellaIsChecked = false;


  function saveRoleTypeCheckboxState(items) {
    checkboxState = [];
    items.forEach(function (item, index) {
      checkboxState[index] = { checked: item.checked };
    });
  }

  function isOnlyItemSelected(selectedItems, itemIndex) {
    let isOnlyItemSelected = true;

    selectedItems.forEach(function (item, index) {
      if (
        (index === itemIndex && item.checked !== true) ||
        (index !== itemIndex && item.checked !== false)
      ) {
        isOnlyItemSelected = false;
      }
    });
    return isOnlyItemSelected;
  }

  $scope.checkAllReedOrgs = function (
    givenOrgsAsJson,
    searchTerm,
    supplierOrgs
  ) {
    if($scope.procurerIsChecked) return;
    const filteredOrgs = givenOrgsAsJson.filter(function (item) {
      return searchTerm
        ? item.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
            item.isReedOrg
        : item.isReedOrg;
    });
    const ids = filteredOrgs.map(function (item) {
      return item.id;
    });
    supplierOrgs.map(function (item) {
      return (item.checked = ids.includes(item.value) ? true : item.checked);
    });
  };

  $scope.checkAllSupportSupplierOrgs = function (
      givenOrgsAsJson,
      searchTerm,
      supplierOrgs
  ) {
    if($scope.supportSupplierIsChecked) return;
    const filteredOrgs = givenOrgsAsJson.filter(function (item) {
      return searchTerm
        ? item.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
            item.isSupportSupplier
        : item.isSupportSupplier;
    });
    const ids = filteredOrgs.map(function (item) {
      return item.id;
    });
    supplierOrgs.map(function (item) {
      return (item.checked = ids.includes(item.value) ? true : item.checked);
    });
  };

  $scope.checkAllUmbrellaOrgs = function (
    givenOrgsAsJson,
    searchTerm,
    supplierOrgs
  ) {
    if($scope.umbrellaIsChecked) return;
    const filteredOrgs = givenOrgsAsJson.filter(function (item) {
      return searchTerm
        ? item.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
            item.isUmbrellaOrg
        : item.isUmbrellaOrg;
    });
    const ids = filteredOrgs.map(function (item) {
      return item.id;
    });
    supplierOrgs.map(function (item) {
      return (item.checked = ids.includes(item.value) ? true : item.checked);
    });
  };

  /** Called when individual checkbox values are changed, or on 'check all' and 'uncheck all' */
  $scope.applyConditionalSelectLogic = function (
    roleTypeItems,
    supplierItems,
    supplierBehaviour,
    procurerItems,
    procurerBehaviour
  ) {
    console.log("called")
    const candidateIndex = roleTypeItems.findIndex(function (item) {
      return item.label === "Candidate";
    });
    const procurerIndex = roleTypeItems.findIndex(function (item) {
      return item.label === "Procurer";
    });
    const supplierIndex = roleTypeItems.findIndex(function (item) {
      return item.label === "Supplier";
    });

    // Candidate Selected Logic
    if (roleTypeItems[candidateIndex].checked) {
      saveRoleTypeCheckboxState(roleTypeItems);
      roleTypeItems.flatMap(function (item) {
        return [(item.checked = false), (item.ngDisabled = true)];
      });
      supplierBehaviour.isRequired = true;
      procurerBehaviour.isRequired = true;
      roleTypeItems[candidateIndex].checked = true;
      roleTypeItems[candidateIndex].ngDisabled = false;
      $scope.isCandidateChecked = true;
    }
    if (
      !roleTypeItems[candidateIndex].checked &&
      checkboxState[candidateIndex] &&
      checkboxState[candidateIndex].checked
    ) {
      roleTypeItems.flatMap(function (item, index) {
        return [
          (item.ngDisabled = false),
          (item.checked = checkboxState[index]
            ? checkboxState[index].checked
            : false),
        ];
      });
      supplierBehaviour.isRequired = false;
      procurerBehaviour.isRequired = false;
      roleTypeItems[candidateIndex].checked = false;
      checkboxState = [];
      $scope.isCandidateChecked = false;
    }

    // Procurer Select Logic
    if (
      !roleTypeItems[procurerIndex].checked ||
      !isOnlyItemSelected(roleTypeItems, procurerIndex)
    ) {
      supplierItems.map(function (item) {
        return (item.ngDisabled = false);
      });
      supplierBehaviour.canCheckUncheckAll = true;
      $scope.procurerIsChecked = false;
    }

    if (isOnlyItemSelected(roleTypeItems, procurerIndex)) {
      supplierItems.map(function (item) {
        return (item.ngDisabled = true);
      });
      supplierBehaviour.canCheckUncheckAll = false;
      $scope.procurerIsChecked = true;
    }

    // Supplier Select Logic
    if (
      !roleTypeItems[supplierIndex].checked ||
      !isOnlyItemSelected(roleTypeItems, supplierIndex)
    ) {
      procurerItems.map(function (item) {
        return (item.ngDisabled = false);
      });
      procurerBehaviour.canCheckUncheckAll = true;
    }

    if (isOnlyItemSelected(roleTypeItems, supplierIndex)) {
      procurerItems.map(function (item) {
        return (item.ngDisabled = true);
      });
      procurerBehaviour.canCheckUncheckAll = false;
    }
  };
  return $scope;
};
candidateMultiselectRoleTypeController.$inject = ["$scope"];
angular
  .module("app")
  .controller(
    "candidateMultiselectRoleTypeController",
    candidateMultiselectRoleTypeController
  );
